<template>
  <div
    class="text-[var(--foreground)] dark:bg-[linear-gradient(109.63deg,var(--color-1)_3.67%,var(--color-2)_83.91%)] bg-[#eaeaea] overflow-hidden relative"
    v-show="hydrated"
  >
    <WrOfficialPartnerHeader />
    <WrHeader />
    <WrWordPressHeader v-if="isWordPressPath" />
    <WrLaravelHeader v-else />
    <WrBreadCrumb class="mt-4 z-30 relative" />

    <div>
      <slot />
    </div>

    <section
      class="grid place-items-center z-10 relative pt-16 lg:pt-32 max-md:px-4 overflow-hidden"
      id="mask-section"
    >
      <ClientOnly>
        <LazyWrAnimatedImg />
      </ClientOnly>
    </section>
    <WrFooter />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";

const route = useRoute();

const isWordPressPath = computed(() => route.path.includes("/wordpress"));
// const isWordPressPath = computed(() => route.path.startsWith('/wordpress'))

import { ref, onMounted } from "vue";
const hydrated = ref(false);
onMounted(() => {
  hydrated.value = true;
});
</script>
